import { FleetCategory } from '@jucy/rentals-api-client/rentals-api-v3/models/FleetCategory';

export const isFleetCategoryEarnEligible = (fleetCategory: FleetCategory) => fleetCategory?.fleetTypeCode !== 'car' && ['FreeSell', 'OnRequest'].includes(fleetCategory?.availability);
